import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormLabel, FormDescription } from "@/components/ui/form";
import { Plus } from "lucide-react";
import { MeetingAttendees } from "../MeetingAttendees";

interface AttendeesSectionProps {
  newAttendee: string;
  setNewAttendee: (val: string) => void;
  onAddAttendee: () => void;
  attendees: string[];
  onRemoveAttendee: (val: string) => void;
  isSubmitting: boolean;
}

export const AttendeesSection: React.FC<AttendeesSectionProps> = ({ 
  newAttendee, 
  setNewAttendee, 
  onAddAttendee, 
  attendees, 
  onRemoveAttendee,
  isSubmitting
}) => (
  <div className="space-y-3">
    <FormLabel>Attendees (Optional)</FormLabel>

    <div className="flex gap-2">
      <Input
        placeholder="Add attendee email or name..."
        value={newAttendee}
        onChange={(e) => setNewAttendee(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onAddAttendee();
          }
        }}
        disabled={isSubmitting}
        className="flex-1"
      />
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={onAddAttendee}
        disabled={!newAttendee.trim() || isSubmitting} title="Add"
      >
        <Plus size={16} />
      </Button>
    </div>

    <MeetingAttendees
      attendees={attendees}
      onRemove={onRemoveAttendee}
      isSubmitting={isSubmitting}
    />

    <FormDescription>Add attendee names or email addresses</FormDescription>
  </div>
);
